export default __webpack_public_path__ + "static/media/117.e78ccf31.jpg";